export default __webpack_public_path__ + "static/media/download.067602df.svg";